import { IonButton, IonCol, IonGrid, IonIcon, IonModal, IonRow } from "@ionic/react";
import { trashOutline, trashSharp } from "ionicons/icons";
import React, { FC, useState } from "react";

interface IProps {
    id:string | string[],
    handleDelete:(e: any) => Promise<void>;
    icon?: boolean,
    children?: React.ReactNode,
    buttonText?: string
};

const ConfirmDeleteBtnModal:FC<IProps> = ({id,handleDelete,icon=true,children,buttonText}) => {
    const [opened, setOpened] = useState(false);

    const handleConfirm = (id:any) => {        
        handleDelete(id)
        setOpened(false);
    };

    return<>
    <IonButton onClick={()=>setOpened(true)} color='danger' size='small'>{icon ? <IonIcon ios={trashOutline} md={trashSharp}/> : buttonText } </IonButton>
    <IonModal isOpen={opened} onDidDismiss={()=>setOpened(false)} className="confirmDelete">
                    <IonGrid>
                            <IonRow className="ion-justify-content-center">
                                <IonCol className="delete-warning">
                                    {children ? children :  'Are You Sure You Want To Delete This? This cannot be undone.'}
                                </IonCol>
                            </IonRow>
                            <IonRow className="ion-justify-content-center">
                                <IonButton color="danger" onClick={()=>handleConfirm(id)} >Delete</IonButton>
                                <IonButton color="medium" onClick={ ()=> setOpened(false)} >Cancel</IonButton>
                            </IonRow>
                    </IonGrid>
                </IonModal>
                </>
};

export default ConfirmDeleteBtnModal;